'use client'
import { AlgoliaContextProvider } from '@/context'
import { HitsWithFacets } from '../products'
import { useState } from 'react'
import PageTitle from '../page-title'
import SortInput from '../sort-input'

type Props = {
  searchParams?: Record<string, string | string[]>
}

const RecipesResults = ({ searchParams }: Props) => {
  const [sort, _] = useState<string>()

  return (
    <AlgoliaContextProvider
      searchParams={searchParams || {}}
      type="recipe"
      openItem="content"
      sorting={sort}
    >
      <PageTitle title="Recipes">
        <SortInput
          options={[
            {
              label: 'DATE: RECENT TO OLDEST',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_CONTENT}`
            },
            {
              label: 'DATE: OLDEST TO RECENT',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_CONTENT}_sort_publishdate_asc`
            },
            {
              label: 'TITLE: A-Z',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_CONTENT}_sort_az`
            },
            {
              label: 'TITLE: Z-A',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_CONTENT}_sort_za`
            },
            {
              label: 'CATEGORY: A-Z',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_CONTENT}_sort_category_az`
            },
            {
              label: 'CATEGORY: Z-A',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_CONTENT}_sort_category_za`
            }
          ]}
        />
      </PageTitle>

      <HitsWithFacets openTab="content" />
    </AlgoliaContextProvider>
  )
}

export default RecipesResults
